import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: () => import(/* webpackChunkName: "homepage" */ 'View/homepage.vue'),
    },
    // 详情独立出来避免与列表之间的缓存问题
    {
      path: '/detail',
      name: 'detail',
      component: () => import(/* webpackChunkName: "detail" */ 'View/service/index.vue'),
      children: [
        {
          path: 'knowledgeDetail',
          name: 'knowledgeDetail',
          meta: {
            name: '专业知识详情',
            favorName: 'knowledgeFavor',
            breadcrumb: [
              { name: '专业服务', routeName: 'homepage' },
              { name: '专业知识', routeName: 'knowledge' },
            ],
          },
          component: () => import(/* webpackChunkName: "knowledgeDetail" */ 'View/service/knowledge/detail.vue'),
        },
        {
          path: 'productDetail',
          name: 'productDetail',
          meta: {
            name: '服务产品详情',
            favorName: 'productFavor',
            breadcrumb: [
              { name: '专业服务', routeName: 'homepage' },
              { name: '服务产品', routeName: 'serviceProduct' },
            ],
          },
          component: () => import(/* webpackChunkName: "serviceProductDetail" */ 'View/service/product/detail.vue'),
        },
        {
          path: 'organizationDetail',
          name: 'organizationDetail',
          meta: {
            name: '服务机构详情',
            favorName: 'orgFavor',
            breadcrumb: [
              { name: '专业服务', routeName: 'homepage' },
              { name: '服务机构', routeName: 'serviceOrg' },
            ],
          },
          component: () => import(/* webpackChunkName: "serviceOrgDetail" */ 'View/service/organization/detail.vue'),
        },
        {
          path: 'requireDetail',
          name: 'requireDetail',
          meta: {
            name: '服务需求详情',
            favorName: 'requireFavor',
            breadcrumb: [
              { name: '专业服务', routeName: 'homepage' },
              { name: '服务需求', routeName: 'serviceRequire' },
            ],
          },
          component: () => import(/* webpackChunkName: "serviceRequireDetail" */ 'View/service/require/detail.vue'),
        },
      ],
    },
    {
      path: '/service',
      name: 'service',
      component: () => import(/* webpackChunkName: "service" */ 'View/service/index.vue'),
      children: [
        {
          path: 'knowledge',
          name: 'knowledge',
          meta: { name: '专业知识', breadcrumb: [{ name: '专业服务', routeName: 'homepage' }], keepAlive: true },
          component: () => import(/* webpackChunkName: "knowledge" */ 'View/service/knowledge/index.vue'),
        },
        {
          path: 'product',
          name: 'serviceProduct',
          meta: { name: '服务产品', breadcrumb: [{ name: '专业服务', routeName: 'homepage' }], keepAlive: true },
          component: () => import(/* webpackChunkName: "serviceProduct" */ 'View/service/product/index.vue'),
        },
        {
          path: 'organization',
          name: 'serviceOrg',
          meta: { name: '服务机构', breadcrumb: [{ name: '专业服务', routeName: 'homepage' }], keepAlive: true },
          component: () => import(/* webpackChunkName: "serviceOrg" */ 'View/service/organization/index.vue'),
        },
        {
          path: 'require',
          name: 'serviceRequire',
          meta: { name: '服务需求', breadcrumb: [{ name: '专业服务', routeName: 'homepage' }], keepAlive: true },
          component: () => import(/* webpackChunkName: "serviceRequire" */ 'View/service/require/index.vue'),
        },
      ],
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ 'View/account/account.vue'),
      children: [
        {
          path: 'login',
          name: 'login',
          redirect: { name: 'loginByPassword' },
          component: () => import(/* webpackChunkName: "login" */ 'View/account/post.vue'),
          children: [
            {
              path: 'loginByPassword',
              name: 'loginByPassword',
              meta: { notShowFooter: true, notShowFloat: true, keepAlive: true },
              component: () => import(/* webpackChunkName: "loginByPassword" */ 'View/account/loginByPassword.vue'),
            },
            {
              path: 'loginByPhone',
              name: 'loginByPhone',
              meta: { notShowFooter: true, notShowFloat: true, keepAlive: true },
              component: () => import(/* webpackChunkName: "loginByPhone" */ 'View/account/loginByPhone.vue'),
            },
            {
              path: 'register',
              name: 'register',
              meta: { notShowFooter: true, notShowFloat: true, keepAlive: true },
              component: () => import(/* webpackChunkName: "register" */ 'View/account/register.vue'),
            },
          ],
        },
        {
          path: 'updatePassword',
          name: 'updatePassword',
          meta: { notShowFooter: true, notShowFloat: true, keepAlive: true },
          component: () => import(/* webpackChunkName: "updatePassword" */ 'View/account/updatePassword.vue'),
        },
      ],
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      redirect: { name: 'favorite' },
      component: () => import(/* webpackChunkName: "userCenter" */ 'View/userCenter/index.vue'),
      children: [
        {
          path: 'favorite',
          name: 'favorite',
          meta: { activeCollapse: 'service' },
          redirect: { name: 'orgFavor' },
          component: () => import(/* webpackChunkName: "favorite" */ 'View/userCenter/favorite/index.vue'),
          children: [
            {
              path: 'orgFavor',
              name: 'orgFavor',
              meta: { activeCollapse: 'service', keepAlive: true },
              component: () => import(/* webpackChunkName: "orgFavor" */ 'View/userCenter/favorite/orgFavor.vue'),
            },
            {
              path: 'productFavor',
              name: 'productFavor',
              meta: { activeCollapse: 'service', keepAlive: true },
              component: () => import(/* webpackChunkName: "productFavor" */ 'View/userCenter/favorite/productFavor.vue'),
            },
            {
              path: 'requireFavor',
              name: 'requireFavor',
              meta: { activeCollapse: 'service', keepAlive: true },
              component: () => import(/* webpackChunkName: "requireFavor" */ 'View/userCenter/favorite/requireFavor.vue'),
            },
            {
              path: 'knowledgeFavor',
              name: 'knowledgeFavor',
              meta: { activeCollapse: 'service', keepAlive: true },
              component: () => import(/* webpackChunkName: "knowledgeFavor" */ 'View/userCenter/favorite/knowledgeFavor.vue'),
            },
          ],
        },
        {
          path: 'myProduct',
          name: 'myProduct',
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "myProduct" */ 'View/userCenter/mine/product.vue'),
        },
        {
          path: 'myRequire',
          name: 'myRequire',
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "myRequire" */ 'View/userCenter/mine/require.vue'),
        },
        {
          path: 'requireRecommendation',
          name: 'requireRecommendation',
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "requireRecommendation" */ 'View/userCenter/recommendation/require.vue'),
        },
        {
          path: 'productRecommendation',
          name: 'productRecommendation',
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "productRecommendation" */ 'View/userCenter/recommendation/product.vue'),
        },
        {
          path: 'orgRecommendation',
          name: 'orgRecommendation',
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "orgRecommendation" */ 'View/userCenter/recommendation/organization.vue'),
        },
        {
          path: 'orgProperty',
          name: 'orgProperty',
          // 此处的keepAlive是为了和上面保持一致，避免父组件重新挂载
          meta: { activeCollapse: 'service', keepAlive: true },
          component: () => import(/* webpackChunkName: "orgProperty" */ 'View/userCenter/service/orgProperty.vue'),
        },
        {
          path: 'basicInformation',
          name: 'basicInfo',
          meta: { activeCollapse: 'information', keepAlive: true },
          component: () => import(/* webpackChunkName: "basicInfo" */ 'View/userCenter/account/basic.vue'),
        },
        {
          path: 'enterpriseInformation',
          name: 'enterpriseInfo',
          meta: { activeCollapse: 'information', keepAlive: true },
          component: () => import(/* webpackChunkName: "enterpriseInfo" */ 'View/userCenter/account/enterprise.vue'),
        },
        {
          path: 'authInformation',
          name: 'authInfo',
          meta: { activeCollapse: 'information', keepAlive: true },
          component: () => import(/* webpackChunkName: "authInfo" */ 'View/userCenter/account/auth.vue'),
        },
        {
          path: 'message',
          name: 'message',
          meta: { activeCollapse: 'message', keepAlive: true },
          component: () => import(/* webpackChunkName: "message" */ 'View/userCenter/message/index.vue'),
        },
      ],
    },
    {
      path: '/require',
      name: 'require',
      meta: {
        name: '发布需求',
        breadcrumb: [
          { name: '个人中心', routeName: 'userCenter' },
          { name: '我的需求', routeName: 'myRequire' },
        ],
      },
      component: () => import(/* webpackChunkName: "require" */ 'View/userCenter/service/require.vue'),
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        name: '发布产品',
        breadcrumb: [
          { name: '个人中心', routeName: 'userCenter' },
          { name: '我的产品', routeName: 'myProduct' },
        ],
      },
      component: () => import(/* webpackChunkName: "product" */ 'View/userCenter/service/product.vue'),
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: { notShowNavbar: true },
      component: () => import(/* webpackChunkName: "aboutUs" */ 'View/other/aboutUs.vue'),
    },
    {
      path: '/agreement',
      name: 'agreement',
      meta: { notShowFloat: true },
      component: () => import(/* webpackChunkName: "agreement" */ 'View/other/agreement.vue'),
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: { notShowFloat: true, name: '意见反馈', breadcrumb: [] },
      component: () => import(/* webpackChunkName: "feedback" */ 'View/other/feedback.vue'),
    },
  ],
});

export default router;
